import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Cloudinfranum() {
  return (
    <section className="cloud_infra_num p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={9}
            xxl={9}
            className="m-auto text-center"
          >
            <h2>
              Why Choose cloud infrastructure management services for your
              business?
            </h2>
          </Col>
        </Row>
        <Row className="mt-md-5 mt-sm-0">
          <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
            <div className="cloud_infra_box">
              <h2>30%</h2>
              <p>
                Simplified IT processes and expandable cloud resources give
                businesses an operational efficiency boost of up to 30%.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
            <div className="cloud_infra_box">
              <h2>95%</h2>
              <p>
                Cloud infrastructure management implementation improves security
                measures and compliance adherence by 95%.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
            <div className="cloud_infra_box">
              <h2>50%</h2>
              <p>
                Using cloud cost management systems saves up to 50% on IT
                expenses by allocating and monitoring costs more efficiently.
              </p>
            </div>
          </Col>

          <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
            <div className="cloud_infra_box">
              <h2>93%</h2>
              <p>
                93% of businesses have implemented a multi-cloud approach,
                emphasizing the importance of scalable infrastructure
                management.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Cloudinfranum;
